import React from 'react';
import clsx from 'clsx';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Icons } from 'components';

export interface IMeasurementToolsSwitcher extends WithTranslation{
    switchMeasurement: (value: string) => void;
    activeTool: string | null
}

const MeasurementToolsSwitcherComponent: React.FC<IMeasurementToolsSwitcher> = (
    { switchMeasurement, activeTool, t }
) => (
    <ul className="oms-measurements">
        <li className="oms-measurements__item" onClick={() => switchMeasurement('Point')}>
            <div className={clsx('oms-measurements__icon-wrapper', (activeTool === 'Point') && 'active')}>
                <Icons.IconPoint />
            </div>
            <span>{ t('LOCATION') }</span>
        </li>
        <li className="oms-measurements__item" onClick={() => switchMeasurement('distance')}>
            <div className={clsx('oms-measurements__icon-wrapper', (activeTool === 'distance') && 'active')}>
                <Icons.IconDistance />
            </div>
            <span>{ t('DISTANCE') }</span>
        </li>
        <li className="oms-measurements__item" onClick={() => switchMeasurement('area')}>
            <div className={clsx('oms-measurements__icon-wrapper', (activeTool === 'area') && 'active')}>
                <Icons.IconArea />
            </div>
            <span>{ t('AREA') }</span>
        </li>
        <li className="oms-measurements__item" onClick={() => switchMeasurement('Circle')}>
            <div className={clsx('oms-measurements__icon-wrapper', (activeTool === 'Circle') && 'active')}>
                <Icons.IconRadius />
            </div>
            <span>{ t('RADIUS') }</span>
        </li>
    </ul>
);

export const MeasurementToolsSwitcher = withTranslation()(MeasurementToolsSwitcherComponent);
